import { Component, Inject, OnInit } from '@angular/core';
import { Alert } from '@sinequa/components/alerts';
import { MODAL_MODEL } from '@sinequa/core/modal';

@Component({
  selector: 'app-filter-modal',
  templateUrl: './filter-modal.component.html',
  styleUrls: ['./filter-modal.component.scss']
})
export class FilterModalComponent implements OnInit {
  model: {
    alert: Alert;
    searchRoute?: string;
  };

  // public form: UntypedFormGroup;
  // public buttons = ['btn1', 'btn2'];
  constructor(
    @Inject(MODAL_MODEL) public data: any,
  ) { }

  ngOnInit(): void {
  }
}
